import { render, staticRenderFns } from "./userForgotModal.vue?vue&type=template&id=57d6bc62&scoped=true"
import script from "./userForgotModal.vue?vue&type=script&lang=js"
export * from "./userForgotModal.vue?vue&type=script&lang=js"
import style0 from "./userForgotModal.vue?vue&type=style&index=0&id=57d6bc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d6bc62",
  null
  
)

export default component.exports